<script>
import HeaderBox from '@/components/HeaderBox.vue'
import CardText from '@/views/Scenario/StepEditor/Card/CardText.vue'
import { CardType } from '@/utils/const'
import CardQuickReply from '@/views/Scenario/StepEditor/Card/CardQuickReply.vue'
import CardImage from '@/views/Scenario/StepEditor/Card/CardImage.vue'
import CardCarousel from '@/views/Scenario/StepEditor/Card/CardCarousel.vue'
import CardConfig from '@/views/Scenario/StepEditor/Card/CardConfig.vue'
import CardAPI from '@/views/Scenario/StepEditor/Card/CardAPI.vue'
import CardForm from '@/views/Scenario/StepEditor/Card/CardForm.vue'
import CardHumanSupport from '@/views/Scenario/StepEditor/Card/CardHumanSupport.vue'
import CardTicket from '@/views/Scenario/StepEditor/Card/CardTicket.vue'
import CardZaloList from '@/views/Scenario/StepEditor/Card/CardZaloList.vue'
import CardUserLocation from '@/views/Scenario/StepEditor/Card/CardUserLocation.vue'
import CardLuaScript from '@/views/Scenario/StepEditor/Card/CardLuaScript.vue'
import CardEmail from '@/views/Scenario/StepEditor/Card/CardEmail.vue'
import CardSuggest from '@/views/Scenario/StepEditor/Card/CardSuggest.vue'
import { mapState } from 'vuex'
import CardKBTrigger from '@/views/Scenario/StepEditor/Card/CardKBTrigger.vue'
import CardKBCall from '@/views/Debugger/card/CardKBCall.vue'
import CardKBMapping from '@/views/Debugger/card/CardKBMapping.vue'
import CardTag from '@/views/Debugger/card/CardTag.vue'
import CardSmartReminder from '@/views/Debugger/card/CardSmartReminder.vue'
import CardUpdateCRM from '@/views/Debugger/card/CardUpdateCRM.vue'
import CardGetCRM from '@/views/Debugger/card/CardGetCRM.vue'
import CardGoToStep from '@/views/Debugger/card/CardGoToStep.vue'

const MapCardTypeToComponent = {
    [CardType.TEXT]: CardText,
    [CardType.GO_TO_STEP]: CardGoToStep,
    [CardType.QUICK_REPLY]: CardQuickReply,
    [CardType.IMAGE]: CardImage,
    [CardType.CAROUSEL]: CardCarousel,
    [CardType.CONFIG]: CardConfig,
    [CardType.JSON_API]: CardAPI,
    [CardType.FORM]: CardForm,
    [CardType.REQUEST_HUMAN_SUPPORT]: CardHumanSupport,
    [CardType.TAG]: CardTag,
    [CardType.TICKET]: CardTicket,
    [CardType.ZALO_LIST_TEMPLATE]: CardZaloList,
    [CardType.REQUEST_USER_LOCATION]: CardUserLocation,
    [CardType.LUA_SCRIPT]: CardLuaScript,
    [CardType.GET_SENDER_ATTRIBUTE]: CardGetCRM,
    [CardType.UPDATE_SENDER_ATTRIBUTE]: CardUpdateCRM,
    [CardType.EMAIL]: CardEmail,
    [CardType.SMART_REMINDER]: CardSmartReminder,
    [CardType.SUGGEST]: CardSuggest,
    [CardType.RATING]: CardText,
    [CardType.KB_TRIGGER]: CardKBTrigger,
    [CardType.KB_CALL]: CardKBCall,
    [CardType.KB_MAPPING]: CardKBMapping
}
export default {
    name: 'ContentSection',
    components: { HeaderBox },
    props: {
        card: Object
    },
    computed: {
        ...mapState('debug', ['cardActive']),
        cardView () {
            return MapCardTypeToComponent[this.card.card_type_id]
        }
    }
}
</script>

<template>
<div class="d-flex flex-column" style="gap:12px">
  <HeaderBox>Content:</HeaderBox>
  <component :is="cardView" :card="card" :class="{'do-not-pointer': !card.card_type_id.includes('kb')}"/>
  <div class="error-box" v-if="cardActive.error">
    <div style="width: 24px; height: 24px">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 10.5858L9.17157 7.75736L7.75736 9.17157L10.5858 12L7.75736 14.8284L9.17157 16.2426L12 13.4142L14.8284 16.2426L16.2426 14.8284L13.4142 12L16.2426 9.17157L14.8284 7.75736L12 10.5858Z" fill="#DC3632"/>
      </svg>
    </div>
    <div class="d-flex flex-column">
      <span class="font-weight-bold">Error</span>
      {{cardActive.error}}
    </div>
  </div>
</div>
</template>

<style lang="scss">
@import '@/views/Scenario/StepEditor/Card/card.scss';
</style>
<style scoped lang="scss">
.error-box {
  border-left: 2px solid #DC3632;
  padding: 8px 12px;
  background-color: #FCEFEF;
  display: flex;
  gap: 12px;
  color: #DC3632;
}
.do-not-pointer {
    pointer-events: none;
}
</style>
